/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { useSelector, useDispatch } from 'react-redux';
// pages
import { Error } from '@insticator/insticator-ui'; // iui-material
import Dashboard from './pages/dashboard/dashboard';
// material
import { Modal, MessageHolder, OnInActivityMessage } from '@insticator/insticator-ui'; // iui-material
// utils
import {
    PrivateRoute, pageurl, device,
    language, languages, cookieEnabled, userAgent, visitorGeo, isMobile,
    isEmptyObject,
    environment,
    clearAutoLogoutTimer, clearCheckInactivityTimer, setAutoLogoutTimer, setCheckInactivityTimer,
    history,
    LoadState
} from '@insticator/insticator-ui'; // iui-utils
import { redirectToPubPortalClassic } from './utils/redirecttopubportalclassic';
// actions
import { fetchUserPermissions } from './state/thunks/session';
import {
    fetchAccountSitesAndApps,
    fetchAccountInfo,
    fetchAccountSettings
} from "./state/thunks/account";

// styles
import injectSheet from 'react-jss';
import styles from './app_styles';


/* ========== ~~~~~~~~~~ APP ~~~~~~~~~~ ========== */
const App = (props) => {
    // ga listener
    history.listen((location) => {
        if(window.gtag) {
            window.gtag('set', 'page', location.pathname + location.search);
            window.gtag('send', 'pageview');
        }
    });

    // redux state
    const isSignedIn = useSelector((state) => state.session.isSignedIn)
    const accountUUID = useSelector((state) => state.session.accountUUID)
    const userUUID = useSelector((state) => state.session.userUUID)
    const permissions = useSelector((state) => state.session.permissions)
    const sites = useSelector((state) => state.account.sites)
    const accountInfoReceived = useSelector((state) => state.account.accountInfoReceived)

    // actions
    const dispatch = useDispatch();

    // component state
    const [isLoading, setIsLoading] = useState(false);

    // component hooks
    useEffect(() => {
        ensurePermissionsAndSitesList()
    }, []);

    // component logic
    const ensurePermissionsAndSitesList = () => {
        if (!isSignedIn) redirectToPubPortalClassic()
        if (userDoesNotHavePermissions()) dispatch(fetchUserPermissions(userUUID))
        if (userDoesNotHaveSites()) {
            dispatch(fetchAccountSitesAndApps(accountUUID))
        }
        if (!accountInfoReceived) {
            dispatch(fetchAccountInfo(accountUUID))
            dispatch(fetchAccountSettings(accountUUID))
        }
        // if (isSignedIn && isLoading) setTimeout(() => setIsLoading(false), 1200)
        if (isSignedIn) initializeHeapScript();
    };

    const initializeHeapScript = () => {
        const heapId = environment === 'PRODUCTION' ? 3324975950 : 3686026769;
        const heapScript = `window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
        heap.load("${heapId}");`;

        const script = document.createElement('script');
        script.text = heapScript;
        document.head.appendChild(script);
    }

    const userDoesNotHavePermissions = () => permissions.length < 1

    const userDoesNotHaveSites = () => isEmptyObject(sites)

    const navigateUserOnPageLoad = () => {
        const path = '/dashboard'
        return <Redirect to={path} />;
    };

    const _renderLoadState = () => <LoadState graphicName={`insticator-icon`} graphicText={`Browser with Search Icon`} bodycopy={`COOL Media is loading your data.`} />;

    if(!isSignedIn) return null;

    if(isLoading) return _renderLoadState();

    return (
        <ConnectedRouter history={history}>
            <div id={`app`} className={`${props.classes.app}`}>
                <Modal />
                <MessageHolder />
                <Switch>
                    <Route exact path='/' render={navigateUserOnPageLoad} />
                    {/* !!! Nested routes to sections are in the Dashboard component !!! */}
                    <PrivateRoute path='/dashboard'
                                  permitted={isSignedIn}
                                  component={Dashboard}
                    />
                    <PrivateRoute path='/profile'
                                  permitted={isSignedIn}
                                  component={Dashboard}
                    />
                    <Route path='/error' component={Error}
                    />
                    <Redirect to='/error/404' />
                </Switch>

            </div>
        </ConnectedRouter>
    );
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(App);
